module.exports = __webpack_public_path__ + "static/img/5.33d5ce9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/5.png
// module id = 31RP
// module chunks = 0